export interface IAuditLog {
  _id: string;
  webhook: any;
  createdAt: Date;
  updatedAt: Date;
  status: EAuditLogStatus;
  failed: boolean;
}

export enum EAuditLogStatus {
  Pending = 'Pending',
  Processed = 'Processed'
}
